import { decrypt } from "../../../utils/encodingdecoding";
import { arjunMerchantId, starblazeMerchantId } from "../../../utils";

export const getColumns = () => {
  const merchantCode = localStorage.getItem("Id");
  const isSuperonMerchant =
    decrypt(merchantCode) === starblazeMerchantId;
  const isArjunOilMerchant =
    decrypt(merchantCode) === arjunMerchantId;

  return [
    {
      Header: "Product Id",
      Footer: "Product Id",
      accessor: "productId",
      sticky: "left",
    },
    {
      Header: "Template Code",
      Footer: "Template Code",
      accessor: "code",
    },

    ...(isSuperonMerchant
      ? []
      : [{
        Header: "Product Name",
        Footer: "Product Name",
        accessor: "productName",
      }]),

    ...(isSuperonMerchant
      ? [
        {
          Header: "Variant",
          Footer: "Variant",
          accessor: "variant",
        },
        {
          Header: "Batch No.",
          Footer: "Batch No.",
          accessor: "batchNo",
        },
        {
          Header: "Product Description",
          Footer: "Product Description",
          accessor: "productName",
        },
        {
          Header: "Date/Time",
          Footer: "Date/Time",
          accessor: "issuedate",
        },

      ]
      : []),

    {
      Header: "Generated QR",
      Footer: "Generated QR",
      accessor: "totalqrcodecount",
    },

    ...(isSuperonMerchant || isArjunOilMerchant
      ? [
        {
          Header: "Quantity",
          Footer: "Quantity",
          accessor: "quantity",
        },
      ]
      : []),

    {
      Header: "Status",
      Footer: "Status",
      accessor: "status",
    },

    ...(isSuperonMerchant || isArjunOilMerchant
      ? [
        {
          Header: "Generate QR",
          Footer: "Generate QR",
          accessor: "generate",
        },
        {
          Header: "Edit",
          Footer: "Edit",
          accessor: "edit",
        },
      ]
      : [{
        Header: "Generate QR",
        Footer: "Generate QR",
        accessor: "action",
      }]),
  ];
};